<template>
    <div id="panel-description" class="panel vh-50">
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Тендер № {{ this.tender.number }} ({{ this.tender.name }})
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        
        <div class="panel-container collapse show overflow-auto">
            <div class="panel-content">
                <div class="description application">
                    <div class="insidescroll" v-html="tender.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tender_header",
    props : {
        tender : {
            type : Object,
            required : true
        }
    }
}
</script>



<style scoped>
.description.application {
    max-height: 220px;
    /* overflow-y: auto; */
}
</style>